<template>
  <div>
    <v-container fluid style="padding: 0 25px;">
      <v-card class="card2" style="margin-top: 10px">
        <v-card-text style="margin-top: -15px;">
          <div style="display: flex;justify-content: space-between;">
            <span style="font-weight: 500;font-size: 28px;"> Model List</span>
            <div style="display: flex;">
              <div class="pa-2 search-panel" style="align-items: center;">
                <!-- Unified search input (Model ID or Name) -->
                <div class="custom-search-input-wrapper">
                  <div class="custom-search-input-container">
                    <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                    <input
                      id="search-keyword-gptmodelmanagement"
                      type="text"
                      placeholder="Search Model ID or Name"
                      class="custom-search-input"
                      v-model="searchKeyword"
                      @keydown.enter="Search"
                    />
                    <v-icon
                      class="clear-icon"
                      :style="searchKeyword ? '' : 'color: transparent !important;'"
                      @click="searchKeyword = ''"
                    >
                      mdi-close-circle
                    </v-icon>
                  </div>
                </div>

                <!-- Category filter dropdown (only show if categories exist) -->
                <div v-if="categories.length > 0" style="display: flex; align-items: center;">
                  <v-autocomplete
                    v-model="searchCategoryId"
                    :items="[{ id: null, name: 'All Categories' }, ...dedupeCategories(categories)]"
                    item-title="name"
                    item-value="id"
                    density="compact"
                    variant="outlined"
                    no-data-text="No matching categories"
                    :menu-props="{ maxHeight: 320 }"
                    hide-details
                    style="min-width: 150px; font-size: 13px;"
                    @update:modelValue="Search"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="16" style="color: #1976D2; margin-right: 2px;">mdi-tag-outline</v-icon>
                    </template>
                  </v-autocomplete>
                </div>

                <!-- Add Category button (always visible) -->
                <v-btn
                  icon
                  variant="text"
                  density="comfortable"
                  size="small"
                  @click="openCategoryDialog"
                >
                  <v-icon size="20" color="#1976D2">mdi-tag-plus</v-icon>
                  <v-tooltip activator="parent" location="top">Add Category</v-tooltip>
                </v-btn>
              </div>

              <div class="custom-vertical-divider"></div>

              <!-- ส่วนปุ่มการทำงาน -->
              <div style="display: flex;">
                <div class="action-controls">
                  <!-- Import Button -->
                  <v-btn
                    id="button-import-gptmodelmanagement"
                    color="#C32E0E"
                    class="control-btn import-btn"
                    variant="outlined"
                    size="large"
                    @click="triggerFileUpload"
                    rounded="lg"
                  >
                  <v-img :src="templateImg" alt="Template" class="template-icon"> </v-img>
                    Import
                    <v-tooltip activator="parent" location="top">
                      Import file configuration
                    </v-tooltip>
                  </v-btn>
                  
                  <!-- Create Button -->
                  <v-btn
                    id="button-create-gptmodelmanagement"
                    color="primary"
                    class="control-btn create-btn"
                    variant="flat"
                    size="small"
                    prepend-icon="mdi-plus"
                    @click="Add()"
                    rounded="lg"
                  >
                    CREATE
                    <v-tooltip activator="parent" location="top">
                      Create new GPT model
                    </v-tooltip>
                  </v-btn>
                </div>
                
                <!-- Hidden File Uploader -->
                <DragDropFile
                  ref="fileUploader"
                  :dialog="true"
                  :DragDrop="false"
                  :ShowListFile="false"
                  :NameButton="nameButton"
                  accept=".json"
                  @filesUploaded="processUpload($event)"
                  :allowType="['application/json']"
                  class="d-none"
                />
              </div>
            </div>
          </div>
        </v-card-text>
        <v-data-table-server
          v-model:options="options"
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          :items="menus"
          :headers="headers"
          :loading="loadingTable"
          style="padding: 0px 16px 0 16px;"
        >
          <template v-slot:item="{ item }">
            <tr>
              <!-- Model ID -->
              <td style="text-align: start; width: 70px;">
                <span style="font-size: 13px;">{{ item.modelDisplay }}</span>
              </td>

              <!-- Model Name + Status + Category -->
              <td style="max-width: 220px;">
                <div style="display: flex; align-items: center; gap: 6px;">
                  <span class="text-truncate-cell" style="font-size: 13px; max-width: 220px;">
                    {{ item.modelName }}
                    <v-tooltip v-if="item.modelName && item.modelName.length > 20" activator="parent" location="top">{{ item.modelName }}</v-tooltip>
                  </span>
                  <span
                    :style="{
                      width: '9px',
                      height: '9px',
                      borderRadius: '50%',
                      backgroundColor: item.isPublish ? '#4CAF50' : '#c1c3cb',
                      display: 'inline-block',
                      flexShrink: '0',
                      cursor: 'default'
                    }"
                  >
                    <v-tooltip activator="parent" location="top">
                      {{ item.isPublish ? 'Published' : 'Draft' }}
                    </v-tooltip>
                  </span>
                  <span v-if="item.categoryName" class="category-tag">
                    <v-icon size="13" style="margin-right: 3px;">mdi-tag-outline</v-icon>
                    <span class="text-truncate-cell" style="max-width: 80px;">{{ item.categoryName }}</span>
                    <v-tooltip v-if="item.categoryName && item.categoryName.length > 10" activator="parent" location="top">{{ item.categoryName }}</v-tooltip>
                  </span>
                </div>
              </td>

              <!-- Description -->
              <td style="text-align: start; max-width: 200px;">
                <span v-if="item.description" class="text-truncate-cell" style="font-size: 12px; color: #555; max-width: 200px; display: block;">
                  {{ item.description }}
                  <v-tooltip v-if="item.description.length > 30" activator="parent" location="top" max-width="300">{{ item.description }}</v-tooltip>
                </span>
                <span v-else style="color: #bbb; font-size: 12px;">—</span>
              </td>

              <!-- Action Menu -->
              <td style="width: 50px;">
                <v-menu location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-btn icon v-bind="props" variant="text" density="comfortable">
                      <v-icon id="icon-iconmenu-gptmodelmanagement" size="22">mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list style="border-radius: 15px;">
                    <v-list-item @click="changePublishNow(item, true)">
                      <v-list-item-title id="list-publish-gptmodelmanagement">Publish</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="Replace(item.modelId, item.modelName)">
                      <v-list-item-title id="list-replace-gptmodelmanagement">{{ $t("gpt_model_management_replace") }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="Version(item.modelId, item.modelIDGroup)">
                      <v-list-item-title id="list-version-gptmodelmanagement">{{ $t("gpt_model_management_version_history") }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="Exportfileconfig(item.modelId)">
                      <v-list-item-title id="list-exportfileconfig-gptmodelmanagement">{{ $t("gpt_model_management_export_file_config") }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>

              <!-- Model (LLM Model Name) -->
              <td style="text-align: start; max-width: 160px;">
                <span class="text-truncate-cell" style="font-size: 13px; max-width: 160px; display: block;">
                  {{ item.model }}
                  <v-tooltip v-if="item.model && item.model.length > 22" activator="parent" location="top">{{ item.model }}</v-tooltip>
                </span>
              </td>

              <!-- Created By -->
              <td style="text-align: center; max-width: 120px;">
                <span class="text-truncate-cell" style="font-size: 13px; max-width: 120px; display: block; margin: 0 auto;">
                  {{ item.createBy }}
                  <v-tooltip v-if="item.createBy && item.createBy.length > 15" activator="parent" location="top">{{ item.createBy }}</v-tooltip>
                </span>
              </td>

              <!-- Actions -->
              <td style="text-align: center; width: 100px;">
                <div style="display: flex; justify-content: center; gap: 2px;">
                  <v-btn id="button-edit-uploadCSV" variant="text" density="comfortable" @click="Edit(item)" icon>
                    <img :src="images.edit" alt="Edit" style="width: 25px; height: 25px;" />
                    <v-tooltip activator="parent" location="top">Edit</v-tooltip>
                  </v-btn>
                  <v-btn
                    id="button-delete-uploadCSV"
                    variant="text"
                    density="comfortable"
                    @click="DeleteGroup(item)"
                    v-if="item.modelDisplay != 1"
                    icon
                    :disabled="btnDisableDelete(item)"
                  >
                    <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px;" />
                    <v-tooltip activator="parent" location="top">Delete</v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
          
          <!-- Table Footer with Total Results -->
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>Total results {{ searchTotalTable }}</div>

              <v-data-table-footer
                :items-per-page-options="[10, 20, 50]"
                v-model:items-per-page="itemsPerPage"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <!-- Header with Title and Close Button -->
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Delete</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem">
            Are you sure you want to delete model {{ deleteItem.modelDisplay }} "<strong>{{ deleteItem.modelName }}</strong>" ?
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <v-icon left size="18">mdi-trash-can-outline</v-icon>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Category Dialog -->
    <v-dialog v-model="dialog_addCategory" max-width="560px" persistent>
      <v-card style="border-radius: 16px !important; overflow: hidden;">
        <div style="background: linear-gradient(180deg, #ffffff 0%, #eef4ff 100%); display: flex; justify-content: space-between; align-items: center; padding: 14px 12px 14px 24px;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <v-icon color="#1976D2" size="22">mdi-tag-multiple-outline</v-icon>
            <span style="font-size: 18px; font-weight: 600; color: #1976D2;">Manage Categories</span>
          </div>
          <v-btn icon variant="text" size="small" @click="closeCategoryDialog">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text style="padding: 24px 24px 16px 24px;">
          <v-combobox
            v-model="newCategoryName"
            :items="categoryNameOptions"
            label="Search or add category"
            variant="outlined"
            density="comfortable"
            no-data-text="Type a new tag to add"
            :menu-props="{ maxHeight: 260 }"
            prepend-inner-icon="mdi-tag-search-outline"
            autofocus
            clearable
            @keydown.enter.prevent="SaveCategory"
            :rules="[categoryNameRequiredRule]"
            hide-details="auto"
            style="border-radius: 12px;"
          />

          <div class="category-manager-summary">
            <span class="category-manager-label">Existing Categories</span>
            <v-chip size="small" color="#E3F2FD" text-color="#1565C0">{{ filteredCategoryDialogItems.length }}</v-chip>
          </div>

          <div class="category-manager-list">
            <div v-if="filteredCategoryDialogItems.length === 0" class="category-manager-empty">
              <v-icon size="18" color="#90A4AE">mdi-tag-off-outline</v-icon>
              <span>No categories found</span>
            </div>
            <div
              v-for="category in filteredCategoryDialogItems"
              :key="category.id || category.name"
              class="category-manager-item"
            >
              <div class="category-manager-name">
                <v-icon size="16" color="#1976D2">mdi-tag-outline</v-icon>
                <span>{{ category.name }}</span>
              </div>
              <div class="category-manager-actions">
                <v-btn icon variant="text" size="small" @click="openRenameCategoryDialog(category)">
                  <v-icon size="18" color="#1976D2">mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" @click="deleteCategory(category)">
                  <v-icon size="18" color="#D32F2F">mdi-trash-can-outline</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions style="padding: 0 24px 16px 24px; display: flex; justify-content: flex-end; gap: 10px;">
          <v-btn class="delete-cancel-btn" @click="closeCategoryDialog">Cancel</v-btn>
          <v-btn
            style="background: linear-gradient(90deg, #1976D2 0%, #42A5F5 100%) !important; color: white !important; border-radius: 11px !important; height: 40px !important; min-width: 100px !important; text-transform: none !important; font-weight: 500 !important; box-shadow: 0 2px 8px rgba(25,118,210,0.25) !important;"
            :disabled="!normalizeCategoryDisplayName(newCategoryName)"
            @click="SaveCategory"
          >
            <v-icon left size="18" style="margin-right: 4px;">mdi-plus-circle-outline</v-icon>
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_renameCategory" max-width="420px" persistent>
      <v-card style="border-radius: 16px !important; overflow: hidden;">
        <div style="background: linear-gradient(180deg, #ffffff 0%, #eef4ff 100%); display: flex; justify-content: space-between; align-items: center; padding: 14px 12px 14px 24px;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <v-icon color="#1976D2" size="22">mdi-tag-edit-outline</v-icon>
            <span style="font-size: 18px; font-weight: 600; color: #1976D2;">Rename Category</span>
          </div>
          <v-btn icon variant="text" size="small" @click="closeRenameCategoryDialog">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text style="padding: 24px 24px 16px 24px;">
          <v-text-field
            v-model="renameCategoryName"
            label="New category name *"
            variant="outlined"
            density="comfortable"
            :rules="[categoryNameRequiredRule]"
            autofocus
            hide-details="auto"
            @keydown.enter.prevent="RenameCategory"
          />
        </v-card-text>
        <v-card-actions style="padding: 0 24px 16px 24px; display: flex; justify-content: flex-end; gap: 10px;">
          <v-btn class="delete-cancel-btn" @click="closeRenameCategoryDialog">Cancel</v-btn>
          <v-btn
            style="background: linear-gradient(90deg, #1976D2 0%, #42A5F5 100%) !important; color: white !important; border-radius: 11px !important; height: 40px !important; min-width: 100px !important; text-transform: none !important; font-weight: 500 !important; box-shadow: 0 2px 8px rgba(25,118,210,0.25) !important;"
            :disabled="!normalizeCategoryDisplayName(renameCategoryName)"
            @click="RenameCategory"
          >
            <v-icon left size="18" style="margin-right: 4px;">mdi-content-save-edit-outline</v-icon>
            Rename
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Replace -->
    <v-dialog v-model="dialog_replace" persistent max-width="600px">
      <v-card style="border-radius: 15px !important;">
        <v-card-title style="height: 56px;">
          <p class="headline" style="color: #1d4f81">
            {{ $t("gpt_model_management_replace") }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
          <div class="dialog-title-lable">
              <v-icon size="20" style="margin-right: 8px">mdi-swap-horizontal</v-icon>
                <span style="font-size: 16px;">Replace Model</span>
          </div>
            <div style="margin-bottom: 2%">
              <span style="font-weight: 600;">{{ replace_modelName }}</span>
              <v-icon size="20">mdi-chevron-double-right</v-icon>
              <span style="color: #C32E0E; font-weight: bold">
                {{replace_modelName2}}
              </span>
            </div>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    id="model-autocomplete-popupreplace-gptmodelmanagement"
                    :label="'Model*'"
                    :rules="[rules.required]"
                    :items="replace_modelid_lists"
                    item-title="modelName"
                    item-value="modelIDGroup"
                    v-model="replace_modelid_list"
                    class="config-input"
                    clearable
                    outlined
                    required
                    variant="outlined"
                    density="comfortable"
                    hide-details="auto"
                    @update:modelValue="onModelChange"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Outlined red Close button with left icon -->
          <v-btn
            class="replace-close-btn"
            variant="outlined"
            density="comfortable"
            @click="dialog_replace = false"
            style="margin-right: 15px;"
          >
            <v-icon left size="18">mdi-close</v-icon>
            {{$t("close")}}
          </v-btn>

          <!-- Gradient orange Save button with floppy icon -->
          <v-btn
            id="button-replacesave-popupreplace-gptmodelmanagement"
            class="replace-save-btn"
            variant="elevated"
            density="comfortable"
            @click="ReplaceSave"
          >
            <v-icon left size="18">mdi-floppy</v-icon>
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Version -->
    <v-dialog v-model="dialog_version" max-width="800px">
      <v-card style="border-radius: 15px !important;">
        <v-card-title style="height: 56px;">
          <p class="headline" style="color: #1d4f81">
            {{ $t("gpt_model_management_version_history") }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container style="padding: 0;">
          <div class="dialog-title-lable">
              <v-icon size="20" style="margin-right: 8px">mdi-clock-time-three-outline</v-icon>
              <span style="font-size: 16px;">Version History</span>
          </div>
            <v-data-table-server
              id="table-dialogversion-gptmodelmanagement"
              :items-per-page="options_version.itemsPerPage"
              :items-length="totalTable_version"
              v-model:options="options_version"
              :items="menus_version"
              :headers="headers_version_history"
              :items-per-page-options="[5, 10, 15]"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align: start;">
                    <div style="display: flex;align-content: center;align-items: center;justify-content: flex-start;">
                      <div>{{ item.versioning }}</div>
                      <span
                        v-if="item.isPublish === true"
                        style="z-index: 1;">
                        <v-chip class="ml-3" size="small" label style="border-radius: 10px;background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%); color: #fff; font-weight: 500;">
                          {{ $t("latest")
                        }}</v-chip>
                      </span>
                    </div>
                  </td>
                  <td style="text-align: start"><span>{{ item.updateDate }}</span></td>
                  <td style="text-align: center">
                    <v-menu location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-btn 
                        icon 
                        variant="text"
                        density="comfortable"
                        v-bind="props">
                          <v-icon
                            id="icon-iconmenu-popupversion-gptmodelmanagement"
                            size="22"
                            >mdi-dots-horizontal</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list style="border-radius: 15px;">
                        <!--Restore-->
                        <v-list-item
                          :key="item.modelId"
                          @click="changeRestoreNewVersion(item)"
                        >
                          <v-list-item-title
                            id="list-restore-popupversion-gptmodelmanagement"
                            >Restore</v-list-item-title
                          >
                        </v-list-item>
                        <!--View-->
                        <v-list-item @click="view(item)">
                          <v-list-item-title
                            id="list-view-popupversion-gptmodelmanagement"
                            >View</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                  <td style="text-align: start"><span>{{ item.updateBy }}</span></td>
                </tr>
              </template>
              <template v-slot:bottom>
                <div
                  class="d-flex justify-space-between align-center px-4 py-2"
                  style="width: 100%"
                >
                  <div>Total results {{ totalTable_version }}</div>

                  <v-data-table-footer
                    :items-per-page-options="[5, 10, 15]"
                    v-model:items-per-page="itemsPerPage"
                    :page="options.page"
                    :length="Math.ceil(totalTable_version / itemsPerPage)"
                  />
                </div>
              </template>
            </v-data-table-server>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="close-btn" @click="dialog_version = false">
            {{$t("close")}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--dialog version history view-->
    <v-dialog v-model="dialog_View">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">
            {{ $t("gpt_model_management_version_history_detail") }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ModelManagement
              v-if="dialog_View"
              :LLmsModel="GPTModel"
              :editAction="null"
              :modelID="view_modelID"
              :GetDDModel="isParam"
              :page="isPage"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog_View = false">{{
            $t("close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Loading Please Wait... -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>


<script>
import ModelManagement from "@/components/ModelManagement.vue";
import DragDropFile from "@/components/DragDropFile.vue";
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import editImg from "@/assets/Icons/Edit.png";
import deleteImg from "@/assets/Icons/Delete.png";
import templateImg from "@/assets/Icons/user-import.svg";

// use i18n for internationalization
export default {
  name: "GPTModelManagement",
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround",
    "Username",
    "RoleId"
  ],
  components: { ModelManagement, DragDropFile },
  
  data: () => ({
    loadingTable: false,
    checkbox1: false,
    EditdialogUser: false,
    Adddialog: false,
    dialog: false,
    dialog_delete: false,
    deleteItem: null,
    valid: true,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    options_version: {
      page: 1,
      itemsPerPage: 5,
      sortBy: [],
      sortDesc: [],
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    DDVector: [],
    DDProvider: [
      "Azure",
      "Azure Postgresql",
      "Azure Internet",
      "Azure Internet",
      "Azure News",
    ],
    DDModel: [
      {
        provider: "Azure",
        model: "gpt-35-turbo-chat",
        maxPrompt: 4000,
      },
      {
        provider: "Azure",
        model: "gpt-35-turbo-16k",
        maxPrompt: 8000,
      },
      {
        provider: "Azure",
        model: "gpt-4",
        maxPrompt: 6000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-35-postgresql",
        maxPrompt: 4000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-35-16k-postgresql",
        maxPrompt: 8000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-4-postgresql",
        maxPrompt: 6000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-35-Internet",
        maxPrompt: 4000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-35-16k-Internet",
        maxPrompt: 8000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-4-Internet",
        maxPrompt: 6000,
      },
      {
        provider: "Azure News",
        model: "gpt-35-turbo-chat",
        maxPrompt: 4000,
      },
      {
        provider: "Azure News",
        model: "gpt-35-turbo-16k",
        maxPrompt: 8000,
      },
      {
        provider: "Azure News",
        model: "gpt-4",
        maxPrompt: 6000,
      },
    ],
    DDModelShow: [],
    headers: [],
    headers_version_history: [],
    DDGender: [
      {
        id: "m",
        name: "Male",
      },
      {
        id: "f",
        name: "Female",
      },
    ],

    searchKeyword: "",
    searchCategoryId: null,
    categories: [],
    dialog_addCategory: false,
    newCategoryName: "",
    dialog_renameCategory: false,
    renameCategoryName: "",
    renameCategoryTarget: null,
    isSearch: false,
    isFirst: true,
    menus: [],
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    GPTModel: {
      typeLLM: null,
      modelId: null,
      modelName: null,
      provider: null,
      model: null,
      APIVersion: null,
      extension: null,
      description: null,
      promptTemplate: "",
      gender: null,
      vectordbName: null,
      topVDB: null,
      internet: null,
      feedback: null,
      historyCount: null,
      historyMinute: null,
      temperature: null,
      topP: null,
      frequencyPenalty: null,
      presencePenalty: null,
      stop: null,
      maxTokens: null,
      isStream: false,
      versioning: null,
      isPublish: false,
      modelIDGroup: null,
      modelDisplay: null,
      DataIntegrationID: null,
      SqlModelID: null,
      promptSqlNoData: null,
      IntentGroupID: null,
      typingSpeed: null,
      isBypass: null,
      isAllowImage: null,
      isFeedback: null,
      groupReplaceID: null,
      productGroupID: null,
      cosine: null,
      isLongTerm_Memory: null,
      isChainMassage: null,
      lenChainMassage: null,
      len_ShortMemory: null,
      timeSecondChainMassage: null,
      maximumChatInput: null,
      monitorLineUserId: null,
      isShowNameUserMonitor: null,
      monitorSocialId: null,
      forbiddenWord: null,
      GuardRailModelID: null,
      enableTime: null,
      timeZone: null,
      jsonRequest: null,
      isAllowLLMChange: null,
      productTopVDB: null,
      productCosine: null,
      loadingBarFlag: null,
      loadingBarTime: null,
    },
    dialog_replace: false,
    dialog_View: false,
    replace_modelid: 0,
    replace_modelName: "",
    replace_modelName2: "",
    replace_modelid_list: { id: 0, name: "x" },
    replace_modelid_lists: [], //{id:0, name: "x"}
    dialog_version: false,
    menus_version: [],
    menus_modelid_version: 0,
    menus_modeliddisplay_version: 0,
    searchTotalTable_version: 0,
    totalTable_version: 0,
    sortBy: [],
    sortDesc: [],

    isParam: "getModel",
    isPage: "Model Creator",
    view_modelID: null,
    view_Model: {
      modelId: null,
      modelName: null,
      provider: null,
      model: null,
      APIVersion: null,
      extension: null,
      description: null,
      promptTemplate: "",
      gender: null,
      vectordbName: [],
      groupReplaceID: null,
      productGroupID: null,
      topVDB: null,
      internet: null,
      feedback: null,
      historyCount: null,
      historyMinute: null,
      temperature: null,
      topP: null,
      frequencyPenalty: null,
      presencePenalty: null,
      stop: null,
      maxTokens: null,
      isStream: false,
      isBypass: false,
      isFeedback: false,
      isAllowImage: false,
      versioning: null,
      isPublish: true,
      modelIDGroup: null,
      modelDisplay: null,
      Len_ShortMemory: null,
      IsLongTerm_Memory: false,
      IsChainMassage: null,
      LenChainMassage: null,
      TimeSecondChainMassage: null,
      Cosine: null,
      DataIntegrationID: null,
      SqlModelID: null,
      promptSqlNoData: null,
      IntentGroupID: null,
      maximumChatInput: 200000,
      enableTime: null,
      timeZone: null,
    },
    uploadedFiles: [],
    nameButton: "IMPORT FILE",
    entity: null,
    jsonData: {},
    templateImg: templateImg,
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    options_version: {
      handler() {
        if (this.menus_modelid_version != 0)
          this.Version(
            this.menus_modelid_version,
            this.menus_modeliddisplay_version
          );
      },
      deep: true,
    },
  },
  computed: {
    categoryNameOptions() {
      return this.dedupeCategories(this.categories).map((category) => category.name);
    },
    filteredCategoryDialogItems() {
      const keyword = this.normalizeCategoryName(this.newCategoryName);
      const items = this.dedupeCategories(this.categories);

      if (!keyword) {
        return items;
      }

      return items.filter((category) => this.normalizeCategoryName(category.name).includes(keyword));
    },
  },
  methods: {
    normalizeCategoryDisplayName(value) {
      return typeof value === "string" ? value.trim().replace(/\s+/g, " ") : "";
    },
    normalizeCategoryName(value) {
      return this.normalizeCategoryDisplayName(value).toLowerCase();
    },
    categoryNameRequiredRule(value) {
      const rawValue = typeof value === "object" ? value?.name : value;
      return !!this.normalizeCategoryDisplayName(rawValue) || "Required";
    },
    normalizeCategoryOption(category) {
      if (!category) {
        return null;
      }

      const categoryName = this.normalizeCategoryDisplayName(
        typeof category === "string" ? category : (category.name ?? category.categoryName)
      );

      if (!categoryName) {
        return null;
      }

      return {
        id: typeof category === "object" ? (category.id ?? category.categoryID ?? null) : null,
        name: categoryName,
      };
    },
    dedupeCategories(categories) {
      const seen = new Set();

      return (Array.isArray(categories) ? categories : [])
        .map((category) => this.normalizeCategoryOption(category))
        .filter((category) => {
          if (!category) {
            return false;
          }

          const normalizedName = this.normalizeCategoryName(category.name);
          if (!normalizedName || seen.has(normalizedName)) {
            return false;
          }

          seen.add(normalizedName);
          return true;
        });
    },
    findCategoryByName(name, excludeId = null) {
      const normalizedName = this.normalizeCategoryName(name);

      return this.dedupeCategories(this.categories).find((category) => {
        if (excludeId !== null && category.id === excludeId) {
          return false;
        }

        return this.normalizeCategoryName(category.name) === normalizedName;
      }) || null;
    },
    openCategoryDialog() {
      this.dialog_addCategory = true;
      this.closeRenameCategoryDialog();
      this.newCategoryName = "";
      this.GetCategories();
    },
    closeCategoryDialog() {
      this.dialog_addCategory = false;
      this.newCategoryName = "";
    },
    openRenameCategoryDialog(category) {
      this.renameCategoryTarget = category;
      this.renameCategoryName = category.name;
      this.dialog_renameCategory = true;
    },
    closeRenameCategoryDialog() {
      this.dialog_renameCategory = false;
      this.renameCategoryName = "";
      this.renameCategoryTarget = null;
    },
    updateCategoryListsAfterChange() {
      if (this.searchCategoryId && !this.categories.some((category) => category.id === this.searchCategoryId)) {
        this.searchCategoryId = null;
      }

      this.Get();
    },
    triggerFileUpload() {
      // เลือกวิธีใดวิธีหนึ่ง:
      // วิธีที่ 1: ถ้า DragDropFile มี method openFileDialog ที่ expose ออกมา
      if (this.$refs.fileUploader && typeof this.$refs.fileUploader.openFileDialog === 'function') {
        this.$refs.fileUploader.openFileDialog();
      } 
      // วิธีที่ 2: เข้าถึง input file ภายใน DragDropFile โดยตรง (ถ้าเป็นไปได้)
      else if (this.$refs.fileUploader && this.$refs.fileUploader.$el) {
        const fileInput = this.$refs.fileUploader.$el.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.click();
        }
      }
    },
    Refresh() {
      this.EditdialogUser = false;
      // window.location.reload();
    },
    Search() {
      let self = this;
      self.dialog = true;
      self.isSearch = true;
      self.options.page = 1;
      self.GetDefault();
    },
    Get() {
      let self = this;
      self.loadingTable = true;
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        modelName: self.searchKeyword,
        modelDisplayId: /^\d+$/.test((self.searchKeyword || '').trim()) ? parseInt(self.searchKeyword) : null,
        categoryId: self.searchCategoryId || null,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableGPTModel(
        temp,
        (dataResponse) => {
          self.loading = false;
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      let self = this;
      self.dialog = true;
      const { itemsPerPage } = self.options;
      let temp = {
        page: 1,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        modelName: self.searchKeyword,
        modelDisplayId: /^\d+$/.test((self.searchKeyword || '').trim()) ? parseInt(self.searchKeyword) : null,
        categoryId: self.searchCategoryId || null,
        sortDesc: null,
        sortBy: null,
      };
      self.$call.GetTableGPTModel(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    DeleteGroup(item) {
      this.deleteItem = item;
      this.dialog_delete = true;
    },
    confirmDelete() {
      let self = this;
      if (!self.deleteItem) return;
      
      try {
        self.dialog_delete = false;
        self.dialog = true;
        
        self.$call.DeleteGPTModel(
          self.deleteItem.modelId,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = "✔ " + dataResponse.message;
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                background: 'transparent',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
              self.EditdialogUser = false;
              self.Get();
            } else if (dataResponse.status == 1) {
              self.$swal.fire({
                icon: "error",
                title: dataResponse.message,
                showConfirmButton: true,
                confirmButtonText: this.$t("gotIt"),
                confirmButtonColor: "#d33",
              });
            }
            self.dialog = false;
            self.deleteItem = null;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            self.deleteItem = null;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
        self.deleteItem = null;
      }
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    Add() {
      let self = this;
      self.$router.push({
        name: "GPTModelDetail",
        query: {
          id: null,
        },
      });
    },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: "GPTModelDetail",
        query: {
          id: item.modelId,
        },
      });
    },
    Clear() {
      let self = this;
      self.EditdialogUser = false;
      self.Adddialog = false;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      return (
        inputValue.length <= this.maxLengthChar ||
        "ฝรุณาฝรอฝข้อมูลตัวอัฝษรไม่เฝิน " +
          this.convertNumberToStringFormat(this.maxLengthChar)
      );
    },
    validateInput0_1(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำ๝หน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return "required.";
      return (
        (value >= 0 && value <= 1 && this.isTwoDecimalPlaces(value)) ||
        "ฝรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำ๝หน่ง"
      );
    },
    validateInput0_2(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำ๝หน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return true;
      return (
        (value >= 0 && value <= 2 && this.isTwoDecimalPlaces(value)) ||
        "ฝรุณาป้อนตัวเลขระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำ๝หน่ง"
      );
    },
    isTwoDecimalPlaces(number) {
      const regex = /^\d+(\.\d{1,2})?$/;
      return regex.test(number.toString());
    },
    convertNumberToStringFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    changeProvider(value) {
      let self = this;
      if (value == null || value == "") {
        self.DDModelShow = self.DDModel;
        return "required.";
      }
      let ddm = self.DDModel.filter((e) => e.provider == value);
      if (ddm.length != 0) {
        self.DDModelShow = self.DDModel.filter((e) => e.provider == value);
      } else {
        self.DDModelShow = self.DDModel;
      }
    },
    changeModel(value) {
      let self = this;
      if (value == null || value == "") {
        self.maxLengthChar = 0;
        return "required.";
      }
      let ddm = self.DDModel.find((e) => e.model == value);
      if (ddm) {
        self.maxLengthChar = self.DDModel.find(
          (e) => e.model == value
        ).maxPrompt;
      }
    },
    changePublishNow(item, is_publish) {
      let self = this;
      self.dialog = true;
      if (item.isPublish == true && is_publish == true) {
        self.dialog = false;
        self.$swal.fire({
          icon: "info",
          title: this.$t("alreadyPublishedModel"),
          showConfirmButton: true,
          confirmButtonText: this.$t("gotIt"),
          confirmButtonColor: "#4BB543",
        });
        return;
      }
      self.$call.PublishGPTModel(
        item.modelId,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            let msgSuccess = "✔ " + 
                this.$t("publish") +
                " " +
                item.modelName +
                " " +
                this.$t("success");
            self.$swal.fire({
              title: msgSuccess,
              showConfirmButton: false,
              timer: 2500,
              position: 'top',
              background: 'transparent',
              customClass: {
                popup: 'success-banner',
                title: 'success-banner-title'
              },
            });
            self.Get();
          }
          self.dialog = false;
          return null;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    changeRestoreNewVersion(item) {
      let self = this;
      self.dialog = true;
      self.$call.PublishGPTModel(
        item.modelId,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            let msgSuccess = "✔ " + 
                this.$t("restoreVersion") +
                " " +
                item.modelName +
                " " +
                this.$t("success");
            self.$swal.fire({
              title: msgSuccess,
              showConfirmButton: false,
              timer: 2500,
              position: 'top',
              background: 'transparent',
              customClass: {
                popup: 'success-banner',
                title: 'success-banner-title'
              },
            });
            self.Get();
          }else if (dataResponse.status == 2) {
            this.$router.push({
              name: "GPTModelDetail",
              query: {
                id: item.modelId,
              },
            });
          }
          self.dialog = false;
          self.dialog_version = false;
          return null;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          self.dialog_version = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    async Save() {
      let self = this;
      self.dialog = true;
      try {
        if (self.GPTModel.modelId == null) {
          await self.$call.AddGPTModel(
            self.GPTModel,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Get();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else if (self.GPTModel.modelId != null) {
          await self.$call.UpdateGPTModel(
            self.GPTModel,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Get();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    async Replace(modelid, modelName) {
      let self = this;
      self.dialog_replace = true;
      self.replace_modelid = modelid;
      self.replace_modelName = modelName;
      self.replace_modelName2 = "";
      self.replace_modelid_list = [];

      let raw = { page: 1, perPage: self.totalTable };
      self.$call.GetTableGPTModel(
        raw,
        (result) => {
          self.replace_modelid_list = [];
          if (result.status == 0) {
            let model = result.data.data.filter((o) => o.modelId == modelid)[0];

            if (model.isPublish == true) {
              let models = result.data.data.filter(
                (o) => o.modelId != modelid && o.isPublish == true
              );
              self.replace_modelid_lists = models;
            } else {
              let models = result.data.data.filter((o) => o.modelId != modelid);
              self.replace_modelid_lists = models;
            }
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (error) => {
          self.dialog = false;
          self.isSearch = false;
          alert(error);
        }
      );
    },
    async ReplaceSave() {
      let self = this;
      self.dialog = true;

      if (self.replace_modelid_list == undefined) {
        self.dialog = false;
        return;
      }

      let model_id = self.replace_modelid;
      // let GPTModel_model_display = self.replace_modelid_lists.filter((o) => o.modelIDGroup == self.replace_modelid_list)[0].modelDisplay;
      let GPTModel_model_id = self.replace_modelid_lists.filter(
        (o) => o.modelIDGroup == self.replace_modelid_list
      )[0].modelId;
      // let GPTModel_is_publish = self.replace_modelid_lists.filter((o) => o.modelIDGroup == self.replace_modelid_list)[0].isPublish;
      self.$call.ReplaceGPTModel(
        {
          source: model_id,
          destination: GPTModel_model_id,
        },
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (dataResponse.status == 0) {
              let msgSuccess ="✔ Successfully Replaced!";
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                background: 'transparent',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
              self.Get();
            }
          }
          self.dialog_replace = false;
          self.dialog = false;
          return null;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          self.dialog_replace = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    async ReplaceChange(value) {
      let self = this;
      self.replace_modelid = value;
    },
    view(val) {
      let self = this;
      // self.dialog_version = false;
      self.view_modelID = val.modelId;
      self.isPage = "view model";
      self.dialog_View = true;
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async Version(modelId, modelIDGroup) {
      let self = this;
      self.dialog = true;
      if (self.dialog_version == false) {
        this.options_version.page = 1;
        this.options_version.itemsPerPage = 5;
      }

      self.dialog_version = true;
      self.menus_modelid_version = modelId;
      self.menus_modeliddisplay_version = modelIDGroup;

      const { page, itemsPerPage } = this.options_version;
      let temp = {
        page: page == undefined ? 1 : page,
        perPage: itemsPerPage,
        modelId: modelId,
        modelIDGroup: modelIDGroup,
      };

      self.$call.GetTableGPTModelVersioning(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (
              dataResponse.data.total == 1 &&
              dataResponse.data.data[0].isPublish == false
            ) {
              self.menus_version = [];
            } else {
              self.menus_version = dataResponse.data.data;
            }
            self.searchTotalTable_version = dataResponse.data.total;
            self.totalTable_version = dataResponse.data.total;
          } else {
            self.menus_version = [];
            self.searchTotalTable_version = 0;
            self.totalTable_version = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Exportfileconfig(id) {
      let self = this;
      let req = {
        modelID: id,
      };
      self.dialog = true;
      self.$call.ExportFileConfigModel(
        req,
        (dataResponse) => {
          self.dialog = false;
          if (dataResponse) {
            // สร้าง FileReader เพื่ออ่าน Blob
            const reader = new FileReader();

            // เมื่อ FileReader โหลดเสร็จ
            reader.onload = function () {
              try {
                // ๝ปลงผลลัพธ์จาฝ FileReader เป็น JSON
                const jsonResponse = JSON.parse(reader.result);
                //ทำฝารจัดฝารไฟล์
                let fileURL = window.URL.createObjectURL(
                  new Blob([JSON.stringify(jsonResponse, null, 2)])
                );
                let fileLink = document.createElement("a");

                fileLink.href = fileURL;
                let fileName = `ExportFileConfigModel_${self.convertDateToString(
                  new Date(),
                  ""
                )}.json`;
                fileLink.setAttribute("download", fileName);
                document.body.appendChild(fileLink);

                fileLink.click();
              } catch (error) {
                console.error("Error parsing JSON:", error);
              }
            };

            // เริ่มอ่าน Blob เป็นข้อความ
            reader.readAsText(new Blob([dataResponse]));
          }
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    convertDateToString2(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },
    convertDateToString(date, seperator = "-") {
      return dateUtils.getStringWithTimeFromDate2(
        moment(date).toDate(),
        seperator
      );
    },
    processUpload(event) {
      let self = this;
      self.files = event;
      const reader = new FileReader();
      const file = self.files[0];
      reader.onload = (e) => {
        try {
          self.jsonData = JSON.parse(e.target.result); // ๝ปลง JSON ที่อัปโหลดได้
          self.ValidateFile(self.files);
          self.ImportFileModelConfig();
        } catch (error) {
          console.error("Invalid JSON file");
        }
      };
      reader.readAsText(file);
    },
    ValidateFile(files) {
      const formDataDoc = new FormData();
      formDataDoc.append("import_file", files[0]);
      this.uploadedFiles = files;
      this.entity = formDataDoc;
    },
    ImportFileModelConfig() {
      let self = this;
      self.dialog = true;
      self.$call.ImportFileModelConfig(
        self.jsonData,
        (dataResponse) => {
          self.dialog = false;
          if (dataResponse.status == 0) {
            let msgSuccess = "✔ " + dataResponse.message;
            self.$swal.fire({
              title: msgSuccess,
              showConfirmButton: false,
              timer: 1500,
              position: 'top',
              background: 'transparent',
              customClass: {
                popup: 'success-banner',
                title: 'success-banner-title'
              },
            });
            self.totalTable = self.totalTable + 1;
            self.Get();
          }
        },
        (errorResource) => {
          self.dialog = false;
          self.Adddialog = false;
          console.error(errorResource);
        }
      );
    },

    onModelChange(value) {
      this.replace_modelName2 = this.replace_modelid_lists.find(e => e.modelIDGroup == value)?.modelName || '';
    },

    GetCategories() {
      let self = this;
      try {
        if (typeof self.$call.GetGPTModelCategory !== 'function') {
          self.categories = [];
          return;
        }
        self.$call.GetGPTModelCategory(
          (dataResponse) => {
            if (dataResponse && dataResponse.status == 0) {
              self.categories = self.dedupeCategories(dataResponse.data || []);
            } else {
              self.categories = [];
            }
          },
          () => { self.categories = []; }
        );
      } catch (e) {
        self.categories = [];
      }
    },
    SaveCategory() {
      let self = this;
      if (!self.normalizeCategoryDisplayName(self.newCategoryName)) {
        self.$swal.fire({
          icon: "warning",
          title: "Category name is required",
          showConfirmButton: true,
          confirmButtonText: "OK",
          confirmButtonColor: "#FFA726",
        });
        return;
      }
      const name = self.normalizeCategoryDisplayName(self.newCategoryName);
      const duplicateCategory = self.findCategoryByName(name);
      const isDuplicate = !!duplicateCategory;
      if (isDuplicate) {
        self.$swal.fire({
          icon: "warning",
          title: `Category "${name}" already exists`,
          showConfirmButton: true,
          confirmButtonText: "OK",
          confirmButtonColor: "#FFA726",
        });
        return;
      }
      try {
        if (typeof self.$call.AddGPTModelCategory !== 'function') {
          return;
        }
        self.$call.AddGPTModelCategory(
          { name },
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = `✔ Category "${name}" created successfully!`;
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: "top",
                background: "transparent",
                customClass: { popup: "success-banner", title: "success-banner-title" },
              });
              self.newCategoryName = "";
              self.GetCategories();
            } else if (dataResponse.status == 1) {
              self.$swal.fire({
                icon: "warning",
                title: dataResponse.message || "Duplicate category name",
                showConfirmButton: true,
                confirmButtonText: "OK",
                confirmButtonColor: "#FFA726",
              });
            }
          },
          (error) => { console.error(error); }
        );
      } catch (e) {
        console.error('AddGPTModelCategory error:', e);
      }
    },
    RenameCategory() {
      let self = this;
      if (!self.renameCategoryTarget?.id) {
        return;
      }

      if (!self.normalizeCategoryDisplayName(self.renameCategoryName)) {
        self.$swal.fire({
          icon: "warning",
          title: "Category name is required",
          showConfirmButton: true,
          confirmButtonText: "OK",
          confirmButtonColor: "#FFA726",
        });
        return;
      }

      const name = self.normalizeCategoryDisplayName(self.renameCategoryName);
      const duplicateCategory = self.findCategoryByName(name, self.renameCategoryTarget.id);
      if (duplicateCategory) {
        self.$swal.fire({
          icon: "warning",
          title: `Category "${name}" already exists`,
          showConfirmButton: true,
          confirmButtonText: "OK",
          confirmButtonColor: "#FFA726",
        });
        return;
      }

      self.$call.UpdateGPTModelCategory(
        { id: self.renameCategoryTarget.id, name },
        (dataResponse) => {
          if (dataResponse.status == 0) {
            const selectedCategoryId = self.searchCategoryId;
            self.$swal.fire({
              title: `✔ Category "${name}" renamed successfully!`,
              showConfirmButton: false,
              timer: 1500,
              position: "top",
              background: "transparent",
              customClass: { popup: "success-banner", title: "success-banner-title" },
            });
            self.closeRenameCategoryDialog();
            self.GetCategories();
            self.updateCategoryListsAfterChange();
            self.searchCategoryId = selectedCategoryId;
            return;
          }

          self.$swal.fire({
            icon: "warning",
            title: dataResponse.message || "Duplicate category name",
            showConfirmButton: true,
            confirmButtonText: "OK",
            confirmButtonColor: "#FFA726",
          });
        },
        (error) => { console.error(error); }
      );
    },
    deleteCategory(category) {
      let self = this;
      self.$swal.fire({
        icon: "warning",
        title: `Delete category "${category.name}"?`,
        text: "Models using this category will be cleared.",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#d33",
      }).then((result) => {
        if (!result.isConfirmed) {
          return;
        }

        self.$call.DeleteGPTModelCategory(
          category.id,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                title: `✔ Category "${category.name}" deleted successfully!`,
                showConfirmButton: false,
                timer: 1500,
                position: "top",
                background: "transparent",
                customClass: { popup: "success-banner", title: "success-banner-title" },
              });
              if (self.searchCategoryId === category.id) {
                self.searchCategoryId = null;
              }
              if (self.renameCategoryTarget?.id === category.id) {
                self.closeRenameCategoryDialog();
              }
              self.GetCategories();
              self.updateCategoryListsAfterChange();
              return;
            }

            self.$swal.fire({
              icon: "warning",
              title: dataResponse.message || "Unable to delete category",
              showConfirmButton: true,
              confirmButtonText: "OK",
              confirmButtonColor: "#FFA726",
            });
          },
          (error) => { console.error(error); }
        );
      });
    },
    btnDisableDelete(item) {
      if ((this.RoleId == 2 || this.RoleId == 6) && item.createBy != this.Username) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.GetDate();
    this.GetCategories();
    this.headers = [
      {
        title: "Model ID",
        value: "model_id",
        align: "start",
        sortable: false,
        width: "70px",
      },
      {
        title: "Model Name",
        value: "ModelName",
        align: "start",
        sortable: true,
        width: "220px",
      },
      {
        title: "Description",
        value: "Description",
        align: "start",
        sortable: false,
        width: "200px",
      },
      // {
      //   title: "Category",
      //   value: "Category",
      //   align: "start",
      //   sortable: false,
      // },
      { title: " ", value: " ", align: "center", sortable: false, width: "50px" },
      {
        title: "Model",
        value: "ModelNameDisplay",
        align: "start",
        sortable: true,
        width: "160px",
      },
      {
        title: "Created by",
        value: "CreateBy",
        align: "center",
        sortable: true,
        width: "120px",
      },
      {
        title: this.$t("Manage"),
        value: "Manage",
        align: "center",
        width: "100px",
        sortable: false,
      }
    ];
    this.headers_version_history = [
      { title: "Version", align: "start", sortable: false, width: "150px" },
      { title: "Modified", align: "start", sortable: false },
      { title: " ", align: "center", sortable: false },
      { title: "Modified By", align: "start", sortable: false },
    ];
    // this.Get();
  },
};
</script>

<style scoped>
/* Custom Delete Dialog Styles */
.delete-dialog-card {
  border-radius: 8px !important;
  padding: 0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden !important;
}

.delete-dialog-header {
  background: linear-gradient(180deg, #ffffff 0%, #fff1f0 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 6px 10px 24px !important;
}

.delete-dialog-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #dc3545 !important;
  margin: 0 !important;
}

.delete-close-icon {
  color: #6c757d !important;
  margin: 0 !important;
}

.delete-close-icon:hover {
  background-color: #f8f9fa !important;
}

.delete-dialog-content {
  font-size: 14px !important;
  color: #212529 !important;
  text-align: left !important;
  padding: 24px !important;
  line-height: 1.6 !important;
  border-bottom: 1px solid #dee2e6 !important;
  margin-bottom: 12px !important;
}

.delete-dialog-actions {
  padding: 0 24px 14px 24px !important;
  justify-content: flex-end !important;
  gap: 12px !important;
}

.delete-cancel-btn {
  background-color: white !important;
  color: #495057 !important;
  border: 1px solid #ced4da !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  box-shadow: none !important;
  height: 40px !important;
  min-width: 90px !important;
}

.delete-cancel-btn:hover {
  background-color: #f8f9fa !important;
  border-color: #adb5bd !important;
}

.delete-confirm-btn {
  background-color: #C30000 !important;
  color: white !important;
  border: none !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  height: 40px !important;
  min-width: 100px !important;
}

.delete-confirm-btn:hover {
  background-color: #c82333 !important;
}

.delete-confirm-btn .v-icon {
  margin-right: 6px;
}

.replace-close-btn {
  border: 1px solid #C32E0E !important; /* red outline */
  color: #C32E0E !important;
  background: transparent !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  height: 40px !important;
  width: 100px !important;
}
.replace-close-btn .v-icon {
  margin-right: 6px;
}
.replace-save-btn {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important; /* orange gradient */
  color: #fff !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  height: 40px !important;
  width: 120px !important;
  box-shadow: 0 4px 10px rgba(195,46,14,0.25) !important;
}
.replace-save-btn .v-icon {
  margin-right: 6px;
}
</style>
<style scoped>
.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: none !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.card {
  border-radius: 16px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* ปรับแต่ง responsive */
@media (max-width: 600px) {
  .justify-end {
    justify-content: flex-start;
  }
}

/* Custom Vertical Divider */
.custom-vertical-divider {
  width: 1px;
  height: 40px;
  background: rgba(0, 0, 0, 0.1);
  margin: 0 16px;
  align-self: center;
  border-radius: 1px;
}

/* Action Controls */
.action-controls {
  display: flex;
  align-items: center;
  background: transparent;
  padding: 4px 8px;
  border: none;
  transition: all 0.2s ease;
  gap: 16px;
}

/* Control Buttons */
.control-btn {
  font-weight: 500;
  letter-spacing: 0.025em;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.import-btn {
  border-radius: 12px !important;
  width: 120px;
  height: 40px;
  color: #C32E0E !important;
  font-size: 13px !important;
  background-color: transparent !important;
  border: 1px solid #C32E0E !important;
}

.create-btn {
  width: 120px;
  box-shadow: 0 1px 3px rgba(25, 118, 210, 0.2);
  border-radius: 12px !important;
  margin: 0 !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-controls {
    width: 100%;
    justify-content: space-between;
    min-width: auto;
  }
  
  .control-btn {
    flex: 1;
    margin: 0 2px;
  }
}
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 14px;
  align-self: center;
  border-radius: 1px;
}

/* Table improvements */
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

/* Body rows - ไม่มี border, สะอาด */
:deep(.v-data-table tbody tr:hover) {
  background-color: #F8F9FA !important;
}

:deep(.v-data-table .v-table__wrapper > table > tbody > tr > td) {
  border: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr > th) {
  border: none !important;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-start .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}

/* Search panel improvements */
.search-panel {
  gap: 16px;
}

/* Header improvements */
:deep(.v-toolbar) {
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
}

/* Smooth animations */
* {
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, 
              transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

/* Loading states */
.v-skeleton-loader {
  border-radius: 12px !important;
}

/* Focus states */
.control-btn:focus-visible {
  outline: 2px solid rgb(25, 118, 210);
  outline-offset: 2px;
}

/* Custom scrollbar */
:deep(.v-data-table__wrapper)::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: transparent;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.headline {
  font-weight: 600 !important;
  font-size: 26px !important;
  color: #171717 !important;
  margin: 10px 0 0 15px;
}
.dialog-title-lable{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  margin: 0 -50px 10px -50px;
}
:deep(thead) {
  background-color: #FFE4E1 !important;
}
.close-btn {
  border: 1px solid #C32E0E !important; /* red outline */
  color: #C32E0E !important;
  background: transparent !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  height: 40px !important;
  width: 100px !important;
}

/* Dropdown items per page */
:deep(.v-data-table-footer .v-field) {
  border-radius: 10px !important;
  width: 70px !important;
}
:deep(.v-data-table-footer .v-select) {
  width: 80px !important;
}

.config-input {
    margin-bottom: 0px;
}

.config-input :deep(.v-field) {
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
}

.config-input :deep(.v-field:hover) {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.template-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.category-manager-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
  margin-bottom: 12px;
}

.category-manager-label {
  font-size: 13px;
  font-weight: 600;
  color: #4b5563;
}

.category-manager-list {
  max-height: 280px;
  overflow-y: auto;
  border: 1px solid rgba(25, 118, 210, 0.12);
  border-radius: 12px;
  background: #fafcff;
}

.category-manager-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.category-manager-item:last-child {
  border-bottom: none;
}

.category-manager-name {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #1f2937;
  font-size: 13px;
}

.category-manager-name span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.category-manager-actions {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.category-manager-empty {
  min-height: 96px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #90a4ae;
  font-size: 13px;
}

/* Category tag badge */
.category-tag {
  display: inline-flex;
  align-items: center;
  background: #EBF3FF;
  color: #1565C0;
  border: 1px solid #BBDEFB;
  border-radius: 20px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  max-width: 130px;
}

/* Text truncation utility */
.text-truncate-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
